import type { AppMenuConfig, AppMenuItem } from '@workspace/ui';
import raw from './menu-items.json';

export interface MenuItem extends AppMenuItem {
  children?: MenuItem[];
  requiresTenant?: boolean;
}

export interface MenuConfig extends AppMenuConfig {
  sideMenu: MenuItem[];
  topMenu: MenuItem[];
  userMenu: MenuItem[];
}

export const menuConfig = raw as MenuConfig;
